import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MaterialUITooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import Theme from 'LegacyWeployDesignLanguage/Theme';
import { HelpIcon } from 'LegacyWeployDesignLanguage/icons';

const styles = {
  tooltip: {
    backgroundColor: Theme.colors.darkerGrey,
    fontSize: Theme.typography.small,
    color: Theme.colors.white,
    boxShadow: `0 2px 3px ${Theme.colors.shadow}, 0 0 0 1px ${Theme.colors.shadow}`,
    verticalAlign: 'middle',
  },
};

const IconContainer = styled.span`
  margin-left: ${props => props.theme.space.quarter};
`;

const HelpToolTip = ({ classes, text, placement }) => (
  <MaterialUITooltip
    title={text}
    placement={placement}
    classes={{ tooltip: classes.tooltip }}
  >
    <IconContainer>
      <HelpIcon />
    </IconContainer>
  </MaterialUITooltip>
);

HelpToolTip.propTypes = {
  placement: PropTypes.string,
  classes: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
};

HelpToolTip.defaultProps = {
  placement: 'right',
};

export default withStyles(styles)(HelpToolTip);
